@if (isReady) {
  <div>
    <button
      mat-stroked-button
      class="view-menu tall-button"
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="menu"
      (menuClosed)="onClose()"
    >
      <span fxFlex fxLayout="row" fxLayoutAlign="space-between center">
        <span
          >{{ selectedView.name | platformLabel
          }}{{ selectedView.isModified ? ' *' : '' }}</span
        >
        <mat-icon> arrow_drop_down</mat-icon>
      </span>
    </button>
    <mat-menu #menu="matMenu">
      <div class="view-menu-container" (keydown)="$event.stopPropagation()">
        <div class="menu-header">
          <h3>{{ title }}</h3>
          @if (doesPlanAllowSavingViews && !hideSearch) {
            <div class="search-container" appThrottleClick>
              <input
                type="text"
                class="search-input"
                placeholder="Find view"
                [(ngModel)]="searchText"
              />
              <mat-icon class="search-icon md-24">search</mat-icon>
            </div>
          }
          <mat-divider></mat-divider>
        </div>
        <div class="scrollable-section">
          @for (view of systemViews; track view) {
            <button
              mat-menu-item
              (click)="onSelectView(view)"
              [class.selected]="view.isSelected"
              aria-label="Set view as default"
            >
              @if (canMarkAsDefault) {
                <mat-icon
                  class="pin"
                  [class.material-icons-outlined]="!view.isDefault"
                  appThrottleClick
                  (throttledClick)="setDefault(view)"
                  >push_pin</mat-icon
                >
              }
              {{ view.name | platformLabel }} {{ view.isModified ? '*' : '' }}
            </button>
          }
          @if (doesPlanAllowSavingViews) {
            <div>
              @if (myViews.length) {
                <div>
                  <mat-divider></mat-divider>
                  <h5>MY VIEWS</h5>
                  @for (view of myViews | orderBy: 'name'; track view) {
                    <button
                      mat-menu-item
                      (click)="onSelectView(view)"
                      [class.selected]="view.isSelected"
                    >
                      <div>
                        @if (canMarkAsDefault) {
                          <mat-icon
                            class="pin"
                            [class.material-icons-outlined]="!view.isDefault"
                            appThrottleClick
                            (throttledClick)="setDefault(view)"
                            aria-label="Set view as default"
                            >push_pin</mat-icon
                          >
                        }
                        {{ view.name | platformLabel }}
                        {{ view.isModified ? '*' : '' }}
                        @if (view.isPublic) {
                          <span class="shared-tag">Shared</span>
                        }
                      </div>
                      @if (editable) {
                        <div class="item-action-buttons">
                          <mat-icon
                            color="primary"
                            appThrottleClick
                            (throttledClick)="
                              edit.emit(view); menuTrigger.closeMenu()
                            "
                            aria-label="Edit view"
                          >
                            edit</mat-icon
                          >
                          <mat-icon
                            aria-label="Delete view"
                            color="primary"
                            appThrottleClick
                            (throttledClick)="onDelete(view)"
                            >delete</mat-icon
                          >
                        </div>
                      }
                    </button>
                  }
                </div>
              }
              @if (sharedViews.length) {
                <div>
                  <mat-divider></mat-divider>
                  <h5>SHARED VIEWS</h5>
                  @for (view of sharedViews | orderBy: 'name'; track view) {
                    <button
                      mat-menu-item
                      (click)="onSelectView(view)"
                      [class.selected]="view.isSelected"
                    >
                      @if (canMarkAsDefault) {
                        <mat-icon
                          class="pin"
                          [class.material-icons-outlined]="!view.isDefault"
                          appThrottleClick
                          (throttledClick)="setDefault(view)"
                          aria-label="Set view as default"
                          >push_pin</mat-icon
                        >
                      }
                      {{ view.name | platformLabel }}
                      {{ view.isModified ? '*' : '' }}
                      @if (canRemoveOrEdit(view)) {
                        <div class="item-action-buttons">
                          <mat-icon
                            color="primary"
                            appThrottleClick
                            (throttledClick)="
                              edit.emit(view); menuTrigger.closeMenu()
                            "
                            aria-label="Edit view"
                          >
                            edit</mat-icon
                          >
                          <mat-icon
                            color="primary"
                            appThrottleClick
                            (throttledClick)="onDelete(view)"
                            aria-label="Delete view"
                            >delete</mat-icon
                          >
                        </div>
                      }
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
        @if (editable) {
          <div class="menu-footer">
            <mat-divider></mat-divider>
            @if (doesPlanAllowSavingViews) {
              <button
                class="create-button"
                mat-menu-item
                color="primary"
                (click)="create.emit()"
              >
                Create New View
              </button>
            }
            @if (!doesPlanAllowSavingViews) {
              <div class="upgrade">
                <mat-icon>lock</mat-icon>
                <span class="upgrade-text">
                  Upgrade your plan to create custom views.
                  <a (click)="openTenantPlanDialog()">LEARN MORE.</a>
                </span>
              </div>
            }
          </div>
        }
      </div>
    </mat-menu>
  </div>
}
